// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-tapBar {
  display: flex;
  background: var(--color-navLeft-background);
  flex-direction: row;
  width: 100%;
  overflow: auto;
}
.comp-tapBar .tapBar-tap:first-child {
  border-left: 1px solid #353535;
}
.comp-tapBar .tapBar-tap {
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  border-right: 1px solid var(--color-navLeft-border);
  border-bottom: 1px solid var(--color-navLeft-border);
  color: #818181;
  font-family: Ubuntu-L, sans-serif;
  padding: 2px 0px 2px 10px;
  justify-content: space-between;
  gap: 6px;
  -webkit-user-select: none;
          user-select: none;
}
.comp-tapBar .tapBar-tap svg {
  margin-right: -2px;
  color: var(--color-featureColor);
  font-size: 8px;
}
.comp-tapBar .tapBar-tap .button-icon-small {
  opacity: 0;
  display: flex;
  margin-right: 8px;
}
.comp-tapBar .tapBar-tap .button-icon-small svg {
  font-size: 12px;
}
.comp-tapBar .tapBar-tap:hover {
  background: rgba(0, 0, 0, 0.0352941176);
}
.comp-tapBar .tapBar-tap:hover button {
  opacity: 1;
}
.comp-tapBar .tapBar-tapActive {
  color: var(--color-navLeft-button-active);
  border-bottom: 1px solid var(--color-background);
  background-color: var(--color-background);
  border-top: 1px solid var(--color-featureColor);
}
.comp-tapBar .tapBar-tapActive button {
  opacity: 1 !important;
}
.comp-tapBar .tapBar-tapActive:hover {
  background-color: var(--color-background);
}
.comp-tapBar .tapBar-right {
  width: 100%;
  border-bottom: 1px solid var(--color-navLeft-border);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 8px;
}
.comp-tapBar .tapBar-right button {
  display: flex;
}

.comp-breadcrumbs {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  font-family: Ubuntu-L, sans-serif;
  font-size: 12px;
  white-space: break-spaces;
  color: var(--color-backgroundText);
  -webkit-user-select: none;
          user-select: none;
}
.comp-breadcrumbs .hole {
  color: var(--color-featureColor);
  font-size: 8px;
  margin: 0 6px 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/tapbar/tapbar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;EACE,8BAAA;AACJ;AAEE;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mDAAA;EACA,oDAAA;EACA,cAAA;EACA,iCAAA;EACA,yBAAA;EACA,8BAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,gCAAA;EACA,cAAA;AAAN;AAGI;EACE,UAAA;EACA,aAAA;EACA,iBAAA;AADN;AAEM;EACE,eAAA;AAAR;AAKE;EACE,uCAAA;AAHJ;AAII;EACE,UAAA;AAFN;AAME;EACE,yCAAA;EACA,gDAAA;EACA,yCAAA;EACA,+CAAA;AAJJ;AAMI;EACE,qBAAA;AAJN;AAQE;EACE,yCAAA;AANJ;AASE;EACE,WAAA;EACA,oDAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AAPJ;AASI;EACE,aAAA;AAPN;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,yBAAA;EACA,kCAAA;EACA,yBAAA;UAAA,iBAAA;AATF;AAWE;EACE,gCAAA;EACA,cAAA;EACA,mBAAA;AATJ","sourcesContent":[".comp-tapBar {\n  display: flex;\n  background: var(--color-navLeft-background);\n  flex-direction: row;\n  width: 100%;\n  overflow: auto;\n\n  .tapBar-tap:first-child {\n    border-left: 1px solid #353535;\n  }\n\n  .tapBar-tap {\n    cursor: pointer;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    border-right: 1px solid var(--color-navLeft-border);\n    border-bottom: 1px solid  var(--color-navLeft-border);\n    color: #818181;\n    font-family: Ubuntu-L, sans-serif;\n    padding: 2px 0px 2px 10px;\n    justify-content: space-between;\n    gap: 6px;\n    user-select: none; \n\n    svg {\n      margin-right: -2px;\n      color: var(--color-featureColor);\n      font-size: 8px;\n    }\n\n    .button-icon-small {\n      opacity: 0;\n      display: flex;\n      margin-right: 8px;\n      svg {\n        font-size: 12px;\n      }\n    }\n  }\n  \n  .tapBar-tap:hover {\n    background: #00000009;\n    button {\n      opacity: 1;\n    }\n  }\n  \n  .tapBar-tapActive {\n    color: var(--color-navLeft-button-active);\n    border-bottom: 1px solid var(--color-background);\n    background-color: var(--color-background);\n    border-top: 1px solid var(--color-featureColor);\n\n    button {\n      opacity: 1 !important;\n    }\n  }\n\n  .tapBar-tapActive:hover {\n    background-color: var(--color-background);\n  }\n\n  .tapBar-right {\n    width: 100%;\n    border-bottom: 1px solid  var(--color-navLeft-border);\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-right: 8px;\n\n    button {\n      display: flex;\n    }\n  }\n}\n\n.comp-breadcrumbs {\n  display: flex;\n  align-items: center;\n  padding: 4px 8px;\n  font-family: Ubuntu-L, sans-serif;\n  font-size: 12px;\n  white-space: break-spaces;\n  color: var(--color-backgroundText);\n  user-select: none; \n\n  .hole {\n    color: var(--color-featureColor);\n    font-size: 8px;\n    margin: 0 6px 0 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
